module.exports = __webpack_public_path__ + "public/img/towerBigScreenBack.9278cace.png";